export const appendToFormData = <ObjectType = Record<string, any>>(object: ObjectType, formData: FormData) => {
  Object.entries(object)
    .filter(([_, value]) => !!value)
    .forEach(([key, value]) => formData.append(key, value));
};
